import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

// ==============================|| TABLE ACTIONS ROW ||============================== //

export default function TableActions({ children, sx = {} }) {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      justifyContent="center"
      alignItems="center"
      onClick={(e) => e.stopPropagation()}
      sx={sx}
    >
      {children}
    </Stack>
  );
}

TableActions.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};
